import BaseModel from "@kaspernj/api-maker/build/base-model.js"

const modelClassData = {
  "attributes": {
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "stripe_id": {
      "column": {
        "default": null,
        "name": "stripe_id",
        "null": false,
        "type": "string"
      },
      "name": "stripe_id",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "StripeCharge",
  "collectionKey": "stripe_charges",
  "collectionName": "stripe_charges",
  "i18nKey": "stripe_charge",
  "camelizedLower": "stripeCharge",
  "name": "StripeCharge",
  "nameDasherized": "stripe-charge",
  "pluralName": "stripe_charges",
  "ransackable_associations": [
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "auditable_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "ActiveRecordAuditable::Audit",
      "collectionName": "audits",
      "foreignKey": "auditable_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "Audit",
      "through": null
    },
    {
      "className": "StripePaymentIntent",
      "collectionName": "stripe_payment_intents",
      "foreignKey": "latest_charge",
      "name": "latest_charge_on_stripe_payment_intent",
      "macro": "has_one",
      "resource_name": "StripePaymentIntent",
      "through": null
    },
    {
      "className": "StripeCustomer",
      "collectionName": "stripe_customers",
      "foreignKey": "stripe_customer_id",
      "name": "stripe_customer",
      "macro": "belongs_to",
      "resource_name": "StripeCustomer",
      "through": null
    },
    {
      "className": "StripeInvoice",
      "collectionName": "stripe_invoices",
      "foreignKey": "stripe_invoice_id",
      "name": "stripe_invoice",
      "macro": "belongs_to",
      "resource_name": "StripeInvoice",
      "through": null
    },
    {
      "className": "StripeInvoice",
      "collectionName": "stripe_invoices",
      "foreignKey": "stripe_charge_id",
      "name": "stripe_invoices",
      "macro": "has_many",
      "resource_name": "StripeInvoice",
      "through": null
    },
    {
      "className": "StripeOrder",
      "collectionName": null,
      "foreignKey": "stripe_charge_id",
      "name": "stripe_orders",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "StripePaymentIntent",
      "collectionName": "stripe_payment_intents",
      "foreignKey": "payment_intent",
      "name": "stripe_payment_intent",
      "macro": "belongs_to",
      "resource_name": "StripePaymentIntent",
      "through": null
    },
    {
      "className": "StripeRefund",
      "collectionName": null,
      "foreignKey": "stripe_charge_id",
      "name": "stripe_refunds",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "StripeReview",
      "collectionName": null,
      "foreignKey": "stripe_charge_id",
      "name": "stripe_reviews",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    },
    {
      "className": "StripeSource",
      "collectionName": null,
      "foreignKey": "stripe_source_id",
      "name": "stripe_source",
      "macro": "belongs_to",
      "resource_name": null,
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "amount_captured_cents",
      "column": {
        "default": null,
        "name": "amount_captured_cents",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "amount_captured_currency",
      "column": {
        "default": null,
        "name": "amount_captured_currency",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "amount_cents",
      "column": {
        "default": null,
        "name": "amount_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "amount_currency",
      "column": {
        "default": null,
        "name": "amount_currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "amount_refunded_cents",
      "column": {
        "default": null,
        "name": "amount_refunded_cents",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "amount_refunded_currency",
      "column": {
        "default": null,
        "name": "amount_refunded_currency",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "application_cents",
      "column": {
        "default": null,
        "name": "application_cents",
        "null": true,
        "type": "integer"
      }
    },
    {
      "name": "application_currency",
      "column": {
        "default": null,
        "name": "application_currency",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "captured",
      "column": {
        "default": null,
        "name": "captured",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "created",
      "column": {
        "default": null,
        "name": "created",
        "null": true,
        "type": "datetime"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "currency",
      "column": {
        "default": null,
        "name": "currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "description",
      "column": {
        "default": null,
        "name": "description",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "dispute",
      "column": {
        "default": null,
        "name": "dispute",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "failure_code",
      "column": {
        "default": null,
        "name": "failure_code",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "failure_message",
      "column": {
        "default": null,
        "name": "failure_message",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "fraud_details",
      "column": {
        "default": null,
        "name": "fraud_details",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "livemode",
      "column": {
        "default": "1",
        "name": "livemode",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "metadata",
      "column": {
        "default": null,
        "name": "metadata",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "on_behalf_of",
      "column": {
        "default": null,
        "name": "on_behalf_of",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "outcome",
      "column": {
        "default": null,
        "name": "outcome",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "paid",
      "column": {
        "default": null,
        "name": "paid",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "payment_intent",
      "column": {
        "default": null,
        "name": "payment_intent",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "receipt_email",
      "column": {
        "default": null,
        "name": "receipt_email",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "receipt_number",
      "column": {
        "default": null,
        "name": "receipt_number",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "refunded",
      "column": {
        "default": null,
        "name": "refunded",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "review",
      "column": {
        "default": null,
        "name": "review",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "shipping",
      "column": {
        "default": null,
        "name": "shipping",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "source_transfer",
      "column": {
        "default": null,
        "name": "source_transfer",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "statement_descriptor",
      "column": {
        "default": null,
        "name": "statement_descriptor",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "status",
      "column": {
        "default": null,
        "name": "status",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "stripe_customer_id",
      "column": {
        "default": null,
        "name": "stripe_customer_id",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "stripe_id",
      "column": {
        "default": null,
        "name": "stripe_id",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "stripe_invoice_id",
      "column": {
        "default": null,
        "name": "stripe_invoice_id",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "stripe_order_id",
      "column": {
        "default": null,
        "name": "stripe_order_id",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "stripe_source_id",
      "column": {
        "default": null,
        "name": "stripe_source_id",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "transfer_group",
      "column": {
        "default": null,
        "name": "transfer_group",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [],
  "paramKey": "stripe_charge",
  "primaryKey": "id"
}

/** Frontend model for StripeCharge. */
class StripeCharge extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  stripeId() {
    return this.readAttributeUnderscore("stripe_id")
  }

  /** @returns {boolean} */
  hasStripeId() {
    const value = this.stripeId()

    return this._isPresent(value)
  }
}

export default StripeCharge
